import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from "@material-ui/core/styles"
import { Box } from '@material-ui/core'
import TypeOfField from '../../../../FormikFields/TypeOfField'
import siteLanguages from "../../../../../config/sitelanguages.json"
import style from "../style.module.scss"

const Profile = ({ templates, formik, id, backendLanguages }) => {
    const { theme: { bgColors } } = useTheme()
    const { t, i18n: { language: i18nLanguage } } = useTranslation()

    return (
        <Box style={{ backgroundColor: bgColors.bgPrimary0 }} className={`${style.addNewCell}`} margin={1}>
            <div style={{ backgroundColor: bgColors.bgPrimary500 }}
                className={`d-flex justify-content-between align-items-center pr-3 pl-3`}>
                <h4 className={`m-0`}>{t('admin_texttype_profile')} </h4>
            </div>
            <div className={`${style.fields} mt-4`}>
                <TypeOfField freesolo={true} formik={formik} control={"select"}
                    label={t(`admin_texttype_template`)} name={"template"} 
                    disabled={!!id}
                    options={templates.map(t => ({ id: t.id, name: t.name[i18nLanguage] }))}
                />
                <TypeOfField freesolo={true} formik={formik} control={"select"}
                    label={t(`admin_texttype_language`)} name={"language"}
                    options={Object.values(siteLanguages).map(l => ({ id: l.payloadName, name: t(l.name) }))}
                />
                {Object.keys(backendLanguages).map((key) => (
                    <TypeOfField formik={formik} control={"text"}
                        label={t(`admin_texttype_name-${backendLanguages[key].nativeName.toLowerCase()}`)} name={`name${key}`}
                        placeholder={t(`admin_texttype_name-${backendLanguages[key].nativeName.toLowerCase()}-placeholder`)} />
                ))}
                {Object.keys(backendLanguages).map((key) => (
                    <TypeOfField formik={formik} rows={3} control={"textarea"}
                        label={t(`admin_texttype_description-${backendLanguages[key].nativeName.toLowerCase()}`)} name={`description${key}`}
                        placeholder={t(`admin_texttype_description-${backendLanguages[key].nativeName.toLowerCase()}-placeholder`)} />
                ))}
            </div>
        </Box>
    )
}

export default Profile